import React from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import { useFormikContext } from 'formik-2';
import TextField from '../../../components/molecules/TextField';
import { WarningMessage } from '../../../components/widgets';
import FormSection from '../FormSection';
import FormField from '../FormField';
import { ATTRIBUTION_TAB_IDS, TRANSLATE_PREFIX } from '../../consts';
import AppLevelMacroSection from './AppLevelMacroSection';
import EventMappingSection from './EventMappingSection';
import PostbackEventsPlatformsTable from './PostbackEventsPlatformsTable';
import PostbackUrlBaseSection from './PostbackUrlBaseSection';
import css from './PostbackOverallSetupTab.css';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.POSTBACK_OVERALL_SETUP_TAB`;
const TAB_ID = ATTRIBUTION_TAB_IDS.POSTBACK_OVERALL_SETUP;

const PostbackOverallSetupTab = ({ translate, readOnly = false }) => {
    const { values, setFieldValue } = useFormikContext();
    const tabData = values.formData?.[TAB_ID] || {};
    const setTabField = (field, value) => setFieldValue(`formData.${TAB_ID}.${field}`, value);

    return (
        <FormSection
            titleKey={`${TRANSLATE_PREFIX}.TABS.POSTBACK_OVERALL_SETUP`}
            descriptionKey={`${TAB_PREFIX}.DESCRIPTION`}
            iconName="send"
        >
            <WarningMessage
                type="info"
                showIcon={false}
                collapsible
                collapsibleTitle={`${TAB_PREFIX}.INFO_TITLE`}
                defaultExpanded
                message={`${TAB_PREFIX}.INFO_CONTENT`}
            />
            <FormField
                labelKey={`${TAB_PREFIX}.EVENTS_AND_PLATFORMS_LABEL`}
                required={!readOnly}
                subtitleKey={`${TAB_PREFIX}.EVENTS_AND_PLATFORMS_SUBTITLE`}
                fullWidth
                anchor="postback_events_and_platforms"
            >
                <PostbackEventsPlatformsTable readOnly={readOnly} />
            </FormField>
            <PostbackUrlBaseSection readOnly={readOnly} />
            <AppLevelMacroSection readOnly={readOnly} />
            <EventMappingSection readOnly={readOnly} />
            <FormField labelKey={`${TAB_PREFIX}.ADDITIONAL_NOTES_LABEL`} className={css.additionalNotesField} fullWidth>
                <TextField
                    type="textarea"
                    value={tabData.additional_notes || ''}
                    inputConfig={{
                        placeholder: translate(`${TAB_PREFIX}.ADDITIONAL_NOTES_PLACEHOLDER`),
                        rows: 3,
                    }}
                    onChange={val => setTabField('additional_notes', val)}
                    disabled={readOnly}
                    containerClass={css.additionalNotesTextarea}
                    inputClassName={css.additionalNotesInput}
                />
            </FormField>
        </FormSection>
    );
};

PostbackOverallSetupTab.propTypes = {
    translate: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
};

export default withLocalize(PostbackOverallSetupTab);
